import { memo } from 'react';
import { cn, NavArrows, RawHtml, useMedias } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import GalleryWithButtons from '@Components/GalleryWithButtons';
import FeatureItem from '../FeatureItem';
import styles from './ProductFeatures.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { Feature } from '../FeatureItem';

export interface ProductFeaturesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  description: string;
  features: Feature[];
}

const ProductFeatures: FC<ProductFeaturesProps> = (props) => {
  const { className, features, description, ...restProps } = props;
  const { isDesktop } = useMedias();
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {description && <RawHtml html={description} className={styles.description} />}
      {features?.length > 0 && (
        <GalleryWithButtons
          hasTrack={isDesktop}
          cnTrack={styles.scrollbar}
          renderButtons={({ onNext, onPrev }) => (
            <div className={styles.navArrowsContainer}>
              <div className={styles.navTitle}>{t('advantages')}</div>
              {!isDesktop && <NavArrows onPrev={onPrev} onNext={onNext} />}
            </div>
          )}
        >
          {features.map((feature, index) => {
            const isLast = index === features.length - 1;

            return (
              <div key={index} className={cn(styles.itemWrapper, { [styles.last]: isLast })}>
                <FeatureItem feature={feature} itemProp={index === 0 ? 'description' : undefined} />
              </div>
            );
          })}
        </GalleryWithButtons>
      )}
    </div>
  );
};

export default memo(ProductFeatures);
